/* eslint-disable import/prefer-default-export */
import styled from "styled-components";

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 60px 32px;
  min-height: calc(100vh - 200px);

  .pricing-header {
    text-align: center;
    margin-bottom: 60px;

    .pricing-title {
      font-size: 48px;
      font-weight: bold;
      color: ${({ theme }) => theme.primaryDark};
      margin-bottom: 16px;
    }

    .pricing-subtitle {
      font-size: 18px;
      color: ${({ theme }) => theme.primary70};
      margin: 0;
    }
  }

  .pricing-cards {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
    gap: 32px;
    margin-bottom: 40px;

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }

  .pricing-card {
    position: relative;
    border-radius: 12px;
    border: 2px solid ${({ theme }) => theme.primaryLight};
    transition: all 0.3s ease;
    overflow: visible;

    &:hover {
      box-shadow: 0 8px 24px ${({ theme }) => theme.boxShadow10};
      transform: translateY(-4px);
    }

    &.popular {
      border-color: ${({ theme }) => theme.primaryDefault};
      box-shadow: 0 4px 16px ${({ theme }) => theme.boxShadow08};

      &:hover {
        box-shadow: 0 12px 32px ${({ theme }) => theme.boxShadow12};
      }
    }

    .popular-badge {
      position: absolute;
      top: -16px;
      left: 50%;
      transform: translateX(-50%);
      background: linear-gradient(135deg, ${({ theme }) => theme.primaryDefault} 0%, ${({ theme }) => theme.primaryHover} 100%);
      color: ${({ theme }) => theme.white};
      padding: 6px 20px;
      border-radius: 20px;
      font-size: 14px;
      font-weight: 600;
      display: flex;
      align-items: center;
      gap: 6px;
      box-shadow: 0 2px 8px ${({ theme }) => theme.boxShadow08};
    }

    .ant-card-body {
      padding: 40px 32px;
    }

    .plan-header {
      text-align: center;
      margin-bottom: 32px;
      padding-bottom: 24px;
      border-bottom: 1px solid ${({ theme }) => theme.primaryLight};

      .plan-name {
        font-size: 24px;
        font-weight: 600;
        color: ${({ theme }) => theme.primaryDark};
        margin-bottom: 16px;
      }

      .plan-price {
        display: flex;
        align-items: baseline;
        justify-content: center;
        gap: 4px;
        margin-bottom: 12px;

        .price-amount {
          font-size: 48px;
          font-weight: bold;
          color: ${({ theme }) => theme.primaryDefault};
          line-height: 1;
        }

        .price-billing {
          font-size: 18px;
          color: ${({ theme }) => theme.primary70};
        }
      }

      .plan-discount {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 12px;
        margin-bottom: 16px;

        .original-price {
          font-size: 16px;
          color: ${({ theme }) => theme.cGray};
          text-decoration: line-through;
        }

        .discount-badge {
          background: ${({ theme }) => theme.Alert.background.Success};
          color: ${({ theme }) => theme.Alert.borderColor.Success};
          padding: 4px 12px;
          border-radius: 12px;
          font-size: 14px;
          font-weight: 600;
          border: 1px solid ${({ theme }) => theme.Alert.borderColor.Success};
        }
      }

      .trial-info {
        font-size: 16px;
        color: ${({ theme }) => theme.primaryDefault};
        font-weight: 500;
      }
    }

    .plan-features {
      margin-bottom: 32px;
      min-height: 240px;

      .feature-item {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 12px 0;
        font-size: 16px;
        color: ${({ theme }) => theme.primaryDark};

        .check-icon {
          color: ${({ theme }) => theme.primaryDefault};
          font-size: 18px;
        }
      }
    }

    .subscribe-btn {
      height: 48px;
      font-size: 16px;
      font-weight: 600;
      border-radius: 8px;
    }
  }

  .pricing-footer {
    text-align: center;
    padding: 32px;
    background: ${({ theme }) => theme.primaryLight};
    border-radius: 8px;
    margin-top: 40px;

    p {
      font-size: 14px;
      color: ${({ theme }) => theme.primary70};
      margin: 0;
      line-height: 1.6;
    }
  }

  .success-container,
  .cancel-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: calc(100vh - 300px);
    padding: 40px 20px;
  }

  .success-card,
  .cancel-card {
    max-width: 600px;
    width: 100%;
    border-radius: 12px;
    box-shadow: 0 4px 16px ${({ theme }) => theme.boxShadow08};

    .ant-card-body {
      padding: 40px;
    }

    .success-details,
    .cancel-details {
      text-align: left;
      margin-top: 16px;

      p {
        font-size: 16px;
        color: ${({ theme }) => theme.primary70};
        margin-bottom: 12px;
        line-height: 1.6;

        strong {
          color: ${({ theme }) => theme.primaryDark};
        }
      }

      .session-info {
        margin-top: 20px;
        padding: 12px;
        background: ${({ theme }) => theme.primaryLight};
        border-radius: 6px;
        font-size: 14px;

        code {
          background: ${({ theme }) => theme.white};
          padding: 2px 8px;
          border-radius: 4px;
          font-family: monospace;
          color: ${({ theme }) => theme.primaryDefault};
        }
      }
    }
  }
`;

